import "lodash";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";

const Model = {
	namespace: "m_FilterForm",
	state: {
		filterFields: null,
	},
	reducers: {
		saveFilterFields(state, { payload: { filterFields } }) {
			return { ...state, filterFields };
		},
	},
	effects: {
		*updateFilterFields({ payload }, { call, put }) {
			// console.log("@m_FilterForm: payload: ", payload);
			yield put({
				type: "saveFilterFields",
				payload: { filterFields: payload },
			});
		},
	},
	subscriptions: {},
};

export default Model;
